export const ActionTypes = {
  FEEDBACK_ADDED: 'FEEDBACK_ADDED',
  FEEDBACK_REMOVED: 'FEEDBACK_REMOVED',
  SIGN_UP_CLICKED: 'SIGN_UP_CLICKED',
  LOG_IN_CLICKED: 'LOG_IN_CLICKED',
  VIEW_PLANS_CLICKED: 'VIEW_PLANS_CLICKED',
  APP_STORE_CLICKED: 'APP_STORE_CLICKED',
  SOURCE_STARTED: 'SOURCE_STARTED',
  START_SOURCE_INCOMPLETE: 'START_SOURCE_INCOMPLETE',
  STARTING_SOURCE: 'STARTING_SOURCE',
  TRACK_INTERRUPTED: 'TRACK_INTERRUPTED',
  TRACK_STARTED_FROM_SOURCE: 'TRACK_STARTED_FROM_SOURCE',
  COMPONENT_CLICKED: 'COMPONENT_CLICKED',
  COMPONENT_VIEWED: 'COMPONENT_VIEWED',
  IMAGE_FETCH_ERRORED: 'IMAGE_FETCH_ERRORED',
  GRAPHQL_FETCHED: 'GRAPHQL_FETCHED',
} as const;
